import { Component, OnInit } from '@angular/core';
import { LoginService } from '../../service/login.service';
@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {

  date : any
  version : any
  constructor( private loginService: LoginService) {
    this.date = new Date().getFullYear();
    this.version = 2.51
  }

  ngOnInit(): void {
    this.loginService.getVersionInfo().subscribe(
      (res: any) => {
        this.version = res['version']+'.'+res['build']
      },
      err => {
   
      })
  }

}
